/*eslint-disable*/
import styled from "styled-components";
import {CharcoalBlack, DarkSlate, White} from "../../../../theme/variable";
import {media} from "../../../../theme/responsive";
import {validateField} from "../../../../utils/validation";

export const CrossMark = styled.label`
    background: ${White};
    box-shadow: 0 0 1px 0 #000000;
    position: absolute;
    top: -13px;
    right: -16px;
    width: 28px;
    height: 28px;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    border: 1px solid #ccc;
    span {
        color: ${CharcoalBlack};
        font-size: 20px;
        line-height: 18px;
        top: ${(props) => (props.toolTipPosition ? "-6px" : "-9px")};
        position: relative;
        left: -3px;
        ${media.laptop`top: -6px`}
    }
`;
export const UpArrow = styled.div`
    position: absolute;
    top: -3px;
    left: 50%;
    transform: rotate(180deg);
    bottom: 62px;
    opacity: 0;
    &:before,
    &:after {
        content: "";
        border: solid transparent;
        position: absolute;
        top: -6px;
        left: -5px;
        ${media.laptop`top: -6px`}
    }
    &:before {
        border-width: 6px;
        border-bottom-color: transparent;
        margin: -2px 0 0 -1px;
    }
    &:after {
        border-width: 5px;
        border-bottom-color: ${DarkSlate};
    }
`;
export const ToolTipInfo = styled.div`
    background: ${DarkSlate};
    color: ${White};
    width: 100%;
    text-align: left;
    position: absolute;
    bottom: ${(props) => {
        if (validateField(props, "object", "ToolTipStyle.mobile.bottom"))
            return props.ToolTipStyle.mobile.bottom;
        return "26px";
    }};
    right: 0;
    left: 0px;
    transform: translateX(0);
    z-index: -1;
    opacity: 0;
    padding: 8px 12px 8px 8px;
    border-radius: 4px;
    cursor: default;
    ${media.laptop`
        left:${(props) => {
            if (validateField(props, "object", "ToolTipStyle.laptop.left"))
                return props.ToolTipStyle.laptop.left;
            return "-145px";
        }};
        width:315px; 
        bottom: ${(props) => {
            if (validateField(props, "object", "ToolTipStyle.laptop.bottom"))
                return props.ToolTipStyle.laptop.bottom;
            return "26px";
        }};
    `}
`;
export const ToolTipSection = styled.div`
    display: inline-block;
    margin-top: ${(props) => (props.toolTipPosition ? "14px" : "")};
    input[type="checkbox"] {
        display: none;
    }
    input[type="checkbox"]:checked + label > ${UpArrow} {
        opacity: 1;
    }
    input[type="checkbox"]:checked + label + ${ToolTipInfo} {
        opacity: 1;
        z-index: 2;
    }
    ${media.laptop`
        position:${(props) => (props.toolTipPosition ? "absolute" : "relative")};
        right:${(props) => {
            if (validateField(props, "object", "toolTipPosition.laptop.right"))
                return props.toolTipPosition.laptop.right;
            return "";
        }};
        top:${(props) => {
            if (validateField(props, "object", "toolTipPosition.laptop.top"))
                return props.toolTipPosition.laptop.top;
            return "";
        }}; 
        margin-top: ${(props) => (props.toolTipPosition ? "0" : "")};
        `}
`;

export const ToolTipIcon = styled.label`
    && {
        color: ${White};
        font-size: 0.75rem;
        background: ${DarkSlate};
        font-weight: 600;
        width: 16px;
        height: 16px;
        border-radius: 50%;
        line-height: 18px;
        text-align: center;
        cursor: pointer;
        display: inline-block;
        position: relative;
        margin-left: 5px;
    }
`;

export const ToolTipInfoText = styled.div`
    display: inline-block;
    font-weight: 400;
    font-size: 0.8125rem;
    line-height: 18px;
`;
